import { AuthApiService } from './../../services/api/authApi/auth-api.service';
import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable, Injector } from "@angular/core";
import { ToasterService } from "../../services/toaster/toaster.service";
import { ErrorCodes } from '../enums';
import { AuthStore } from '../../store/auth.store';

interface IErrorHandlingStrategy {
    handleErrorResponse(error: HttpErrorResponse): void;
}

@Injectable({ providedIn: 'root' })
export class ErrorHandlerStrategy {
    injector = inject(Injector)
    private authApiService = inject(AuthApiService);
    createErrorInstance(error: HttpErrorResponse): IErrorHandlingStrategy | null {
        if ((error.status === ErrorCodes.unauthorized) && error.url?.includes(this.authApiService.refreshPath)) {
            return this.injector.get(UnAuthorizedErrorResponse);
        }

        return null;
    }
}

@Injectable({ providedIn: 'root' })
export class UnAuthorizedErrorResponse implements IErrorHandlingStrategy {
    private toaster = inject(ToasterService);
    private authStore = inject(AuthStore);
    handleErrorResponse(error: HttpErrorResponse): void {
        this.toaster.addError('Your session has expired, please login again');
        this.authStore.logout();
    }
}

@Injectable({ providedIn: 'root' })
export class NotFoundErrorResponse implements IErrorHandlingStrategy {
    private toaster = inject(ToasterService);
    handleErrorResponse(error: HttpErrorResponse): void {
        // this.toaster.addError('Not Found');
    }
}
